import React from 'react';
import { PrimaryButton } from '@fluentui/react';
import styles from './ContinueButtons.module.scss';

export interface Props {
	label: string;
	onSave: () => void;
}

export const ContinueButtons = (props: Props) => {
	return (
		<div className={styles.buttons}>
			<PrimaryButton text={props.label} iconProps={{ iconName: 'Send' }} onClick={() => props.onSave()} />
		</div>
	);
};
